module.exports = __webpack_public_path__ + "img/HU.85015780.svg";